import { createTestIdHelper } from '../../../lib/utils';

/**
 * Kept out of the component file so that module only exports components: a non-component
 * export there breaks Fast Refresh (`react-refresh/only-export-components`).
 */
export const comingSoonPlaceholderTestId = createTestIdHelper(
  'coming-soon-placeholder',
);

export const comingSoonPlaceholderTestIds = {
  root: comingSoonPlaceholderTestId('root'),
  icon: comingSoonPlaceholderTestId('icon'),
  title: comingSoonPlaceholderTestId('title'),
  description: comingSoonPlaceholderTestId('description'),
  footer: comingSoonPlaceholderTestId('footer'),
} as const;
